export class LayaEnv {
}
LayaEnv.version = "3.4.0";
LayaEnv.isPlaying = true;
LayaEnv.isPreview = false;
LayaEnv.isConch = window ? (window.conch != null) : false;
LayaEnv.isModernAPIs = window ? (window.conchLayaXDevice != null) : false;
LayaEnv.isEditor = false;
